import React from 'react';

import { GIButton, Modal } from 'app-components';
import { FormattedMessage } from 'react-intl';

import { StyledModalButtonFooter } from '../voterRegistration.styled';
import { ModalContextType } from '@contexts/modalContext';
import { configs } from '@constants/configs/configs';
import { useNavigate } from 'react-router-dom';

import useVoterRegistration from '../useVoterRegistration';

interface IModalProps extends ModalContextType {
    applicationId: string;
}

const VoterRegistrationSuccessModal = ({ closeAllModals, applicationId }: IModalProps) => {
    const { stateElectionOfficeLink } = useVoterRegistration();
    const navigate = useNavigate();

    const onContinue = () => {
        closeAllModals();
        navigate(configs.routes.INDPORTAL);
    };

    return (
        <Modal id="voter_registration_success_modal">
            <Modal.Header
                id="modal_header"
                titleId={'voterRegistration.form.modal.success.header'}
                onHide={onContinue}
            />
            <Modal.Body>
                <div>
                    <p>
                        <FormattedMessage
                            id="voterRegistration.form.modal.success.body"
                            values={{
                                anchor: function makeAnchorTag(chunks: any) {
                                    return (
                                        <strong>
                                            <a href={stateElectionOfficeLink} target="_blank" rel="noopener noreferrer">
                                                {chunks}
                                            </a>
                                        </strong>
                                    );
                                },
                            }}
                        />
                    </p>
                    <p className='mt-5'>
                        <FormattedMessage id="voterRegistration.form.modal.success.applicationId" values={{ applicationId }} />
                    </p>
                </div>
            </Modal.Body>
            <Modal.Controls>
                <StyledModalButtonFooter>
                    <GIButton id="Continue_btn" labelId="button.continue" onClickHandler={onContinue} />
                </StyledModalButtonFooter>
            </Modal.Controls>
        </Modal>
    );
};

export default VoterRegistrationSuccessModal;
